module.exports = __webpack_public_path__ + "static/media/Bookndrive_logo.2c49b55d.png";